import type { QueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/lib/constants";

export function invalidateSalesViews(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: ["orders"] });
  queryClient.invalidateQueries({ queryKey: QUERY_KEYS.shifts });
  queryClient.invalidateQueries({ queryKey: ["reports"] });
  queryClient.invalidateQueries({ queryKey: ["customers"] });
}
